export default __webpack_public_path__ + "static/media/login-banner2.521c0523.png";